var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulletedList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5742 5H8.73321C7.84224 5 7.11783 5.72477 7.11783 6.61539C7.11783 7.50636 7.84224 8.23077 8.73321 8.23077H19.5742C20.4649 8.23077 21.1896 7.50636 21.1896 6.61539C21.1896 5.72477 20.4649 5 19.5742 5Z",
    fill: "#494656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5742 10.3846H8.73321C7.84224 10.3846 7.11783 11.1094 7.11783 12C7.11783 12.8909 7.84224 13.6154 8.73321 13.6154H19.5742C20.4649 13.6154 21.1896 12.8909 21.1896 12C21.1896 11.1094 20.4649 10.3846 19.5742 10.3846Z",
    fill: "#494656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5742 15.7693H8.73321C7.84224 15.7693 7.11783 16.4941 7.11783 17.3847C7.11783 18.2756 7.84224 19.0001 8.73321 19.0001H19.5742C20.4649 19.0001 21.1896 18.2756 21.1896 17.3847C21.1896 16.4941 20.4649 15.7693 19.5742 15.7693Z",
    fill: "#494656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4255 5C3.53453 5 2.81012 5.72477 2.81012 6.61539C2.81012 7.50636 3.53453 8.23077 4.4255 8.23077C5.31612 8.23077 6.04089 7.50636 6.04089 6.61539C6.04089 5.72477 5.31612 5 4.4255 5Z",
    fill: "#494656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4255 10.3846C3.53453 10.3846 2.81012 11.1094 2.81012 12C2.81012 12.8909 3.53453 13.6154 4.4255 13.6154C5.31612 13.6154 6.04089 12.8909 6.04089 12C6.04089 11.1094 5.31612 10.3846 4.4255 10.3846Z",
    fill: "#494656"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4255 15.7693C3.53453 15.7693 2.81012 16.4941 2.81012 17.3847C2.81012 18.2756 3.53453 19.0001 4.4255 19.0001C5.31612 19.0001 6.04089 18.2756 6.04089 17.3847C6.04089 16.4941 5.31612 15.7693 4.4255 15.7693Z",
    fill: "#494656"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletedList);
export default __webpack_public_path__ + "static/media/bulleted-list.8275c4c6bd5e80491a85adb6e0f5d2c7.svg";
export { ForwardRef as ReactComponent };